import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, take, tap } from 'rxjs';
import { Treatment } from '../models/treatment.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { TreatmentsService } from '../providers/api/treatments.service';

@Injectable({ providedIn: 'root' })
export class TreatmentService {

  public treatments: Treatment[] = [];
  public treatmentsObject: { [id: string]: Treatment } = {};

  public treatments$: ReplaySubject<Treatment[]> = new ReplaySubject<Treatment[]>(0);
  public treatmentsObject$: ReplaySubject<{ [id: string]: Treatment }> = new ReplaySubject<{
    [id: string]: Treatment;
  }>(0);

  constructor(
    private firestore$: AngularFirestore,
    private treatmentsApi$: TreatmentsService
  ) {
  }

  getAll(): Observable<Treatment[]> {
    // return this.firestore$.collection<Treatment>('treatments',
    //   ref => ref.orderBy('name').orderBy('bonus').orderBy('duration')
    // ).valueChanges({ idField: 'id' })

    return this.treatmentsApi$.treatmentsControllerFindAll()
      .pipe(
        tap((treatments) => {
          const obTreatments = {};
          treatments.forEach(fe => {
            obTreatments[fe.id] = fe;
          });
          this.treatments = treatments;
          this.treatmentsObject = obTreatments;

          this.treatmentsObject$.next(obTreatments);
          this.treatments$.next(treatments);
        }),
        take(1)
      );
  }

  async addTreatment(treatment: Treatment): Promise<void> {
    await this.firestore$.collection('treatments').add({ ...treatment });
    this.getAll().pipe(take(1)).subscribe();
  }

  async updateTreatment(treatment: Treatment): Promise<void> {
    await this.firestore$.doc('treatments/' + treatment.id).update({ ...treatment });
    this.getAll().pipe(take(1));
  }

  async deleteTreatment(treatment: Treatment): Promise<void> {
    await this.firestore$.doc('treatments/' + treatment.id).delete();
    this.getAll().pipe(take(1));
  }
}
